<script lang="ts" setup>
import ButtonPrime, { type ButtonEmits, type ButtonProps, type ButtonSlots } from 'primevue/button'

interface Props extends /* @vue-ignore */ Omit<ButtonProps, 'label' | 'icon'> {
  label?: ButtonProps['label']
  icon?: ButtonProps['icon']
  styleAsInput?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ ButtonEmits {}

const props = defineProps<Props>()
defineEmits<Emits>()

const slots = defineSlots<ButtonSlots>()

const buttonClasses = computed(() => [
  props.class,
  {
    'rounded-[var(--p-inputtext-border-radius)]': props.styleAsInput,
    'md:px-[var(--p-form-field-padding-x)]': props.styleAsInput,
    'md:py-[var(--p-form-field-padding-y)]': props.styleAsInput,
    'px-[var(--p-form-field-sm-padding-x)]': props.styleAsInput,
    'py-[var(--p-form-field-sm-padding-y)]': props.styleAsInput,
  },
])
</script>

<template>
  <ButtonPrime
    v-bind="props"
    :class="buttonClasses"
  >
    <template
      v-for="(_, slot) in slots"
      #[slot]="slotData"
    >
      <slot
        :name="slot"
        v-bind="slotData"
      />
    </template>
  </ButtonPrime>
</template>
